import { useHistory } from 'react-router'
import { lazy, useContext, useEffect, useState } from 'react'
import { AppContext } from '../../app'
import { useToasts } from 'react-toast-notifications'
import * as React from 'react'

const AdminLayout = lazy(() => import('../theme-originals/layout/AdminLayout'))

export const LoggedRoutesContainer = () => {
  const [checking, setChecking] = useState(true)
  const history = useHistory()
  const { user } = useContext(AppContext)
  const { addToast } = useToasts()

  useEffect(() => {
    console.log(
      '[LOGGED ROUTES] Checking user:',
      user ? 'EXISTS' : 'NULL',
      'context:',
      user?.selectedContextEncoded ? 'PRESENT' : 'MISSING'
    )

    if (!user) {
      console.log('[LOGGED ROUTES] No user, redirecting to login')
      history.push('/login')
      addToast('Você precisa estar logado para acessar esta página.', {
        appearance: 'error',
        autoDismiss: true
      })
    } else {
      console.log('[LOGGED ROUTES] User found, allowing access')
      setChecking(false)
    }
  }, [user])

  console.log(
    '[LOGGED ROUTES RENDER] checking:',
    checking,
    'user:',
    user ? 'EXISTS' : 'NULL'
  )

  return checking ? <div>Carregando...</div> : <AdminLayout />
}
